import type { FC } from 'react';
import React from 'react';
import { Stack, Divider } from '@mantine/core';
import classes from './Section.module.css';

interface SectionProps {
  name?: string;
  children?: React.ReactNode;
  headerRight?: React.ReactNode;
  showDivider?: boolean;
  tooltip?: React.ReactNode;
}

export const Section: FC<SectionProps> = (props) => {
  const hasChildren = React.Children.toArray(props.children).length > 0;

  if (!hasChildren && !props.headerRight) {
    return null;
  }

  return (
    <>
      {props.showDivider && <Divider mt="md" />}
      <Stack gap="xs" className={classes.wrapper} data-testid="list-section">
        {props.name && (
          <div className={classes.header}>
            <div className={classes.titleGroup}>
              <div className={classes.title}>{props.name}</div>
              {props.tooltip}
            </div>
            {props.headerRight && <div>{props.headerRight}</div>}
          </div>
        )}
        {hasChildren && <Stack gap="md">{props.children}</Stack>}
      </Stack>
    </>
  );
};
